"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APPSYNC_PAYMENT_TERMINAL_NAMESPACE = exports.APPSYNC_PAYMENT_OPTION_NAMESPACE = exports.APPSYNC_PAYMENT_CONFIG_NAMESPACE = exports.APPSYNC_PAYMENT_V2_NAMESPACE = exports.APPSYNC_PAYMENT_NAMESPACE = exports.EVENT_SUFFIX = void 0;
exports.EVENT_SUFFIX = '_events';
exports.APPSYNC_PAYMENT_NAMESPACE = 'updatedPayment';
exports.APPSYNC_PAYMENT_V2_NAMESPACE = 'updatedPaymentV2';
exports.APPSYNC_PAYMENT_CONFIG_NAMESPACE = 'updatedPaymentConfiguration';
exports.APPSYNC_PAYMENT_OPTION_NAMESPACE = 'updatedPaymentOption';
exports.APPSYNC_PAYMENT_TERMINAL_NAMESPACE = 'updatedTerminal';
//# sourceMappingURL=constants.js.map